import iconArrow from "../../assets/icon_arrow_right.svg";
import useSelectBrand from "#hooks/styles/useSelectBrand";

const Button = ({
  onClick,
  children,
  size = "md",
  cancle = false,
  type,
  arrow = false,
}) => {
  const { color } = useSelectBrand();
  const buttonSize =
    size === "sm" ? "h-14 font-semibold" : "h-16 text-lg font-medium";
  const buttonBg = cancle ? "bg-neutral-200" : `bg-${color}`;
  const buttonArrow = arrow ? "justify-between px-8" : "justify-center";

  return (
    <button
      className={`flex items-center w-full gap-8 rounded-2xl ${buttonSize} ${buttonBg} ${buttonArrow}`}
      onClick={onClick}
      type={type}
    >
      {children}
      {arrow && (
        <span>
          <img src={iconArrow} alt="" />
        </span>
      )}
    </button>
  );
};

export default Button;
